module.exports = __webpack_public_path__ + "img/start.6ba4a158.svg";